// Import SlickSlider
//import "slick-carousel";
import 'slick-carousel/slick/slick.min';

// Global Youtube Players
import YouTubePlayer from 'youtube-player';
let players = [];

// TODO: Migrate to Data-Attributes in Fusion
var options = {
    //slidesToShow: 1,
    //slidesToScroll: 1,
    //infinite: true,
    draggable: false,
    mobileFirst: true,
    prevArrow: '<div class="slick-prev"></div>',
    nextArrow: '<div class="slick-next"></div>',
    //lazyLoad: 'ondemand',
    fade: true,
    cssEase: 'linear',
    speed: 500,
    autoplay: true,
    autoplaySpeed: 6000,
    //dots: true,
    accessibility: false,
}

$('.headerSlideshowWrapper .slideshow').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    var container = $(this);
    var $currentSlide = $(container).find('.slick-slide[data-slick-index="' + currentSlide + '"]').first();
    var $nextSlide = $(container).find('.slick-slide[data-slick-index="' + nextSlide + '"]').first();

    // Pause current Video
    var $youtubeid = $($currentSlide).data('youtubeid');
    if(players[$youtubeid]){
        players[$youtubeid].pauseVideo();
    }

    // Play next Video
    $youtubeid = $($nextSlide).data('youtubeid');
    if(players[$youtubeid]){
        players[$youtubeid].playVideo();
    }

    // Preload Next Slide
    $($nextSlide).find('.slideshow-lazyload').addClass('lazyload').removeClass('.slideshow-lazyload');
});

// Listen for page preloading event.
document.addEventListener('preloaded', function (event) {

    //var startSlide = $('.headerSlideshowWrapper .slideshow .slideshow__slide').first().index();
    $('.headerSlideshowWrapper .slideshow').slick(options);

}, false);


// Load Video on Play
$('.js-video-preview').on('click', function () {
    var $slideshow = $(this).parents('.slideshow');
    var $slide = $(this).parents('.slideshow__slide');
    var $youtubeid = $($slide).data('youtubeid');
    var $video = $($slide).find('.js-video-video');
    $(this).fadeOut();
    $($slideshow).slick('slickPause');

    players[$youtubeid] = YouTubePlayer($video[0], {
        //videoId: $youtubeid,
        host: 'https://www.youtube-nocookie.com',
        playerVars: {
            //'autoplay': 1,
            'controls': 0,
            'modestbranding': 1,
            'theme': 'light',
            'rel': 0,
            'showinfo': 0,
            'playsinline': 1
        },
    });

    // 'loadVideoById' is queued until the player is ready to receive API calls.
    players[$youtubeid].loadVideoById($youtubeid);

    // 'playVideo' is queue until the player is ready to received API calls and after 'loadVideoById' has been called.
    players[$youtubeid].playVideo();
});

